import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Avatar } from '@mui/material'
import Response from '../Response/Response'
import ButtonCustom from '../button/ButtonCustom'
import { formatCommonDate } from '../../../util/formatDateAndTime'
import { formatCommonAmount } from '../../../util/formatAmount'
import styles from './ProposalCard.module.scss'
import { openModal, setModalData } from '../../../features/commonSlice'

function ProposalCard({
	ViewDetail = true,
	proposalId,
	StatusLabel,
	responseLabel = 'Very Responsive', // 🔹 make response dynamic
	title,
	date,
	guests,
	service,
	description,
	price,
	image,
	rawData,
	packageData,
}) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	// 🔹 Map status to SCSS class
	const cardStatusMap = {
		Submitted: 'submitted',
		'In Review': 'in-review',
		Approved: 'approved',
		Declined: 'declined',
		Rejected: 'declined',
	}

	const cardStatusClass = cardStatusMap[StatusLabel] || ''

	return (
		<div className={styles.ProposalCard}>
			{/* Header */}
			<div className={styles.ProposalCardHead}>
				<div className={styles.ProposalCardHeadLeft}>
					<figure className={styles.ProposalCardImage}>
						<Avatar src={image} alt={title} />
					</figure>
					<div className={styles.ProposalCardHeadText}>
						<h2>{title}</h2>
						<div className={styles.ProposalCardHeadTextSub}>
							<p>
								<img
									src="/images/calendar.svg"
									alt="Calendar"
								/>
								<span>{formatCommonDate(date)}</span>
							</p>
							<p>
								<img
									src="/images/TotalGuests.svg"
									alt="Total Guests"
								/>
								<span>{guests}</span>
							</p>
						</div>
					</div>
				</div>
				<div className={styles.ProposalCardResponse}>
					{/* IMPLEMENT LATER */}
					{/* <Response size="md" label={responseLabel} /> */}
				</div>
			</div>

			{/* Body */}
			<div className={styles.ProposalCardBodyMain}>
				{/**
				 * NOTE:: commented as not used now
				 * Uncomment as per require
				 */}
				{/* <div className={styles.ProposalCardBody}>
					<p>{service ?? '--'}</p>
					<span>{description ?? '--'}</span>
				</div> */}

				{packageData?.length ? (
					packageData?.map((item, index) => (
						<div key={index} className={styles.ProposalCardPackage}>
							<p>{item?.name}</p>
							<span>
								Add-ons ({item?.addOnsIds?.length || 0})
							</span>
						</div>
					))
				) : (
					<></>
				)}

				{/* Footer */}
				<div className={styles.ProposalCardFooter}>
					<p>Budget: {formatCommonAmount(price)}</p>
					<div className={styles.ProposalCardFooterBtn}>
						<ButtonCustom
							variant="outlined"
							size="lg"
							onClick={() =>
								navigate(`/vendor-proposal/${proposalId}`)
							}
						>
							View Detail
						</ButtonCustom>
						{/* TODO:: Uncomment when required */}
						{/* {ViewDetail && (
							<ButtonCustom
								size="lg"
								onClick={() => {
									dispatch(openModal('makeBid'))
									dispatch(setModalData(rawData))
								}}
							>
								<img src="/images/Bid.svg" alt="Chat" />
								Make Bid
							</ButtonCustom>
						)} */}
					</div>
				</div>
			</div>

			{/* Status */}
			{StatusLabel && (
				<div
					className={`${styles.ProposalCardStatus} ${
						styles[cardStatusClass]
					}`}
				>
					<p>{StatusLabel}</p>
				</div>
			)}
		</div>
	)
}

export default ProposalCard
